<div class="give-feedback-container">
  <img
    ngSrc="assets/images/need_more_reports_new.svg"
    width="247"
    height="160"
    alt=""
    margin-bottom
  />
  <rt-heading class="heading" variant="large" margin-bottom-small-x>
    {{ 'tlr.component_library_dialog.empty.need_more_reports' | translate }}
  </rt-heading>
  <span> {{ 'tlr.component_library_dialog.empty.let_us_know' | translate }}</span>
  <a
    rt-button
    [href]="'tlr.component_library_dialog.empty.feedback_link' | translate"
    target="_blank"
    variant="outline"
    margin-top
  >
    <span>{{ 'tlr.component_library_dialog.empty.give_feedback' | translate }}</span>
    <rt-icon name="open-in-new" />
  </a>
</div>
